"use strict";
/* --------------------------------------------------------------------------------------------
 *  Licensed to the .NET Foundation under one or more agreements.
 *  The .NET Foundation licenses this file to you under the MIT license.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICommandExecutor = void 0;
class ICommandExecutor {
    constructor(context, utilContext) {
        this.context = context;
        this.utilityContext = utilContext;
    }
    static makeCommand(command, args, isSudo = false) {
        return {
            commandRoot: command,
            commandParts: args,
            runUnderSudo: isSudo
        };
    }
    static prettifyCommandExecutorCommand(command, includeSudo = true) {
        return `${command.runUnderSudo && includeSudo ? `sudo ` : ``}${command.commandRoot} ${command.commandParts.join(' ')}`;
    }
    static replaceSubstringsInCommand(command, substring, replacement) {
        const newCommandRoot = command.commandRoot.replace(substring, replacement);
        const newCommandParts = [];
        for (const commandPart of command.commandParts) {
            newCommandParts.push(commandPart.replace(substring, replacement));
        }
        return {
            commandRoot: newCommandRoot,
            commandParts: newCommandParts,
            runUnderSudo: command.runUnderSudo
        };
    }
    static replaceSubstringsInCommands(commands, substring, replacement) {
        const newCommands = [];
        for (const command of commands) {
            newCommands.push(this.replaceSubstringsInCommand(command, substring, replacement));
        }
        return newCommands;
    }
}
exports.ICommandExecutor = ICommandExecutor;
;
//# sourceMappingURL=ICommandExecutor.js.map